import { ButtonIcon, MenuContent, MenuRoot, MenuTrigger } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import {
  IPlanningDraftSprint,
  PlanningDraftSprintAddChallengeButton,
  PlanningDraftSprintAddLibraryChallengeButton,
} from 'features/planning';

type TPlanningDraftSprintHeaderMenu = {
  sprint: IPlanningDraftSprint;
};

export const PlanningDraftSprintHeaderMenu = ({
  sprint,
}: TPlanningDraftSprintHeaderMenu) => (
  <MenuRoot>
    <MenuTrigger asChild>
      <ButtonIcon
        aria-label="Options"
        data-testid="add-challenge-draft"
        variant="ghost"
      >
        <Icon
          name={iconNames.plus}
          height="10px"
          width="10px"
          strokeWidth={2}
        />
      </ButtonIcon>
    </MenuTrigger>
    <MenuContent position="relative" zIndex={2}>
      <PlanningDraftSprintAddChallengeButton sprint={sprint} />
      <PlanningDraftSprintAddLibraryChallengeButton sprint={sprint} />
    </MenuContent>
  </MenuRoot>
);
